import { call } from '../@';

export type ReportPaidPaymentDto = { id: string; paidAt: Date };

const reportPaidPayment = (dto: ReportPaidPaymentDto) => call('payment-reportPaid', dto);

export default reportPaidPayment;
